import React, {use, useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import Button from "../components/Button";
import styles from "../styles/Cabinet.module.scss";
import MessageBubble from "../components/MessageBubble";

import {CabinetStep, emtyDay} from "../services/types";
import PCWindow from "../components/PCWindow";
import Teach from "../components/Teach";
import PatientCard from "../components/PatientCard";
import {branch0Vera} from "../services/branch0Vera";
import {branch0Aksinya} from "../services/branch0Aksinya";
import {branch0Alexey} from "../services/branch0Alexey";
import {branch0Julia} from "../services/branch0Julia";
import {branch0Sergey} from "../services/branch0Sergey";
import {branch0Ivan} from "../services/branch0Ivan";
import {branch0Alex} from "../services/branch0Alex";
import {branch1Sergey} from "../services/branch1Sergey";
import {branch1Ivan} from "../services/branch1Ivan";
import {branch1Alex} from "../services/branch1Alex";
import {day1StepsType0} from "../services/day1StepsType0";
import Question from "../components/Question";
import {useSound} from "../context/SoundContext";
const base = process.env.PUBLIC_URL || ``;

let dayPatients: any[] = [
    {
        enterPatient: `${base}/images/enter_patient.png`,
        tablePatient: `${base}/images/patient1.png`
    }
]
function getTotalPoints(str:string) : number {
    try {
        const arr = JSON.parse(str);
        return Array.isArray(arr)
            ? arr.reduce((sum, item) => sum + (Number(item.points) || 0), 0)
            : 0;
    } catch {
        return 0;
    }
}
function addStepPointsToCookie(jsonString:string, step: string, points: number) {
    let arr = [];

    try {
        arr = JSON.parse(jsonString);
        if (!Array.isArray(arr)) arr = [];
    } catch {
        arr = [];
    }

    const exists = arr.some(item => item.step === step);

    if (!exists) {
        arr.push({ step, points });
        setCookie('stepPoints', JSON.stringify(arr));
    }

    return arr;
}
function getTotalAchievements(str:string) : number {
    try {
        const arr = JSON.parse(str);
        return arr.length
    } catch {
        return 0;
    }
}

function addStepPointsToAchievements(jsonString:string, step: string) {
    let arr = [];

    try {
        arr = JSON.parse(jsonString);
        if (!Array.isArray(arr)) arr = [];
    } catch {
        arr = [];
    }

    const exists = arr.some(item => item.step === step);

    if (!exists) {
        arr.push({ step });
        setCookie('stepAchievements', JSON.stringify(arr));
    }

    return arr;
}
// function getCookie(name: any) {
//     const matches = document.cookie.match(
//         new RegExp(
//             "(?:^|; )" +
//             name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") +
//             "=([^;]*)"
//         )
//     );
//     return matches ? decodeURIComponent(matches[1]) : undefined;
// }
// function setCookie(name: any, value: any, days = 7) {
//     const expires = new Date(Date.now() + days * 864e5).toUTCString();
//     document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
// }

function setCookie(name: any, value: any, days = 7) {
    try { localStorage.setItem(String(name), String(value)); } catch {}
}

function getCookie(name: any): string | undefined {
    try {
        const v = localStorage.getItem(String(name));
        return v === null ? undefined : v;
    } catch { return undefined; }
}


interface poinModel {
    status: string;
    points_added: string;
    points_total: string;
}


export const CabinetPage = () => {
    const cabinetBody = document.getElementById('root')
    const cabinetBodyBg = document.getElementById('cabinetBodyBg')
    const [steps, setSteps] = useState<any>(null);
    const [buttonsPage, setButtonsPage] = useState<number>(1);
    const [step, setStep] = useState<CabinetStep>(emtyDay);
    const [stepName, setStepName] = useState<string>('');
    const [showPCWindow, setShowPCWindow] = useState(false);
    const [selectedDay, setSelectedDay] = useState(0);
    const [rating, setRating] = useState(0);
    const [currentPoints, setCurrentPoints] = useState(0);
    const [currentAchievements, setCurrentAchievements] = useState(0);
    const [selectedDayType, setSelectedDayType] = useState(0);
    const [windowType, setWindowType] = useState(0);
    const [showPatinetCard, setShowPatinetCard] = useState(false);
    const [showPatinetEnter, setShowPatinetEnter] = useState(false);

    const [historySteps, setHistorySteps] = useState<string[]>(['start']);
    const [currentStep, setCurrentStep] = useState<string>();
    const [oldStep, setOldStep] = useState<string>();
    const [curentLeft, setCurrentLeft] = useState<any>(cabinetBody!!.offsetWidth / 2 - cabinetBody!!.offsetHeight / 2);
    const [curentMoveLeft, setCurrentMoveLeft] = useState<any>(cabinetBody!!.offsetWidth / 2 - cabinetBody!!.offsetHeight / 2);
    const navigate = useNavigate();

    const [dragStartX, setDragStartX] = useState<number | null>(null);
    const [dragDelta, setDragDelta] = useState(0);
    const isDragging = useRef(false);
    const minSwipeDistance = 80;
    const [userData, setUserData] = useState<any>(null);
    const [, forceUpdate] = useState({});

    // const userid = getCookie('userid');

    const branch = getCookie('branch')
    const stepCookie = getCookie('step')
    const stepAchievements = getCookie('stepAchievements')
    const stepPoints = getCookie('stepPoints')


    if (!branch){
        navigate('/')
    }


    // @ts-ignore
    const { muted, toggleMuted } = useSound();
    const handleSound = () => {
        toggleMuted(); // тут меняем значение в контексте
    };


    useEffect(() => {
        if (userData){
            if (stepAchievements){
                setCurrentAchievements(getTotalAchievements(String(getCookie('stepAchievements'))))
            }
            if (stepPoints){
                setCurrentPoints(getTotalPoints(String(getCookie('stepPoints'))))
            }
            if (userData.branch === "1"){
                if (userData.patient === undefined || userData.patient==="Sergey" || userData.patient==="") {
                    userData.patient = "Sergey"
                    setSteps(branch1Sergey)
                }else if (userData.patient==="Ivan"){
                    setSteps(branch1Ivan)
                }else if (userData.patient==="Alex"){
                    setSteps(branch1Alex)
                }
            }else{
                if (userData.patient === undefined || userData.patient==="Alexey" || userData.patient===""){
                    userData.patient="Alexey"
                    setSteps(branch0Alexey)
                }else if (userData.patient==="Aksinya"){
                    setSteps(branch0Aksinya)
                }else if (userData.patient==="Julia"){
                    setSteps(branch0Julia)
                }else if (userData.patient==="Vera"){
                    setSteps(branch0Vera)
                }else if (userData.patient==="Sergey"){
                    setSteps(branch0Sergey)
                }else if (userData.patient==="Ivan"){
                    setSteps(branch0Ivan)
                }else if (userData.patient==="Alex"){
                    setSteps(branch0Alex)
                }
            }
        }
    }, [userData]);

    const getStepsByUser = (data: any) => {

        if (data.branch === "1") {
            if (!data.patient || data.patient === "Sergey") {
                return { ...data, patient: "Sergey" , steps: branch1Sergey };
            } else if (data.patient === "Ivan") {
                return { ...data, steps: branch1Ivan };
            } else if (data.patient === "Alex") {
                return { ...data, steps: branch1Alex };
            }
        } else {
            if (!data.patient || data.patient === "Alexey") {
                return { ...data, patient: "Alexey", steps: branch0Alexey };
            } else if (data.patient === "Aksinya") {
                return { ...data, steps: branch0Aksinya };
            } else if (data.patient === "Julia") {
                return { ...data, steps: branch0Julia };
            } else if (data.patient === "Vera") {
                return { ...data, steps: branch0Vera };
            } else if (data.patient === "Sergey") {
                return { ...data, steps: branch0Sergey };
            } else if (data.patient === "Ivan") {
                return { ...data, steps: branch0Ivan };
            } else if (data.patient === "Alex") {
                return { ...data, steps: branch0Alex };
            }
        }

        return { ...data, steps: branch0Alexey };
    };
    const refreshCabinetState = (incomingUserData?: any) => {
        const data = incomingUserData || userData;
        if (!data) return;

        const prepared = getStepsByUser(data);

        setUserData(prepared);
        setSteps(prepared.steps);

        const nextStepName = prepared.step && prepared.step !== '' ? prepared.step : 'start';
        setStepName(nextStepName);
        setStep(prepared.steps[nextStepName]);

        // console.log(prepared.steps[nextStepName])

        if (prepared.steps[nextStepName].transform === "translateX(0) translateY(-50%)" && prepared.steps[nextStepName].left === "50%"){
            setCurrentMoveLeft(cabinetBody!!.offsetWidth / 2 - cabinetBody!!.offsetHeight / 2)
        }

        setHistorySteps(['start', nextStepName]);
        setButtonsPage(1);

    };



    useEffect(() => {
        if (branch) {
            if (!stepCookie){
            }
            setCurrentPoints(getTotalPoints(String(getCookie('stepPoints'))))

            if (getCookie('step') === undefined){
                setUserData({
                    step: 'start',
                    branch: getCookie('branch'),
                    patient: getCookie('patient')
                })
            }else{
                setUserData({
                    step: getCookie('step'),
                    branch: getCookie('branch'),
                    patient: getCookie('patient')
                })
            }
        }
        if (!branch){
            navigate('/')
        }


    }, [branch]);
    useEffect(() => {
        if (steps) {
            if (userData.step === ''){
                userData.step = 'start'
                setUserData(userData)
            }
            handleClick("nextStep", false, userData.step, userData.patient)

        }
    }, [steps]);


    const handleMouseDown = (e: React.MouseEvent) => {
        isDragging.current = true;
        setDragStartX(e.clientX);
    };
    const handleMouseMove = (e: React.MouseEvent) => {
        if (!isDragging.current || dragStartX === null) return;
        if (document.getElementById('cabinetBody') !== null) {
            if (curentLeft + (e.clientX - dragStartX) > 0) {
                setCurrentMoveLeft(0)
            } else if (curentLeft + (e.clientX - dragStartX) < cabinetBody!!.offsetWidth - cabinetBodyBg!!.offsetWidth) {
            } else {
                setCurrentMoveLeft(curentLeft + (e.clientX - dragStartX))
            }
        }
    };
    const handleMouseUp = () => {
        setCurrentLeft(curentMoveLeft)
        isDragging.current = false;
    };

    const handleTouchStart = (e: React.TouchEvent) => {
        isDragging.current = true;
        setDragStartX(e.touches[0].clientX);
    };
    const handleTouchMove = (e: React.TouchEvent) => {
        if (!isDragging.current || dragStartX === null || !step!.draggable) return;
        if (document.getElementById('cabinetBody') !== null) {
            if (curentLeft + (e.touches[0].clientX - dragStartX) > 0) {
                setCurrentMoveLeft(0)
            } else if (curentLeft + (e.touches[0].clientX - dragStartX) < cabinetBody!!.offsetWidth - cabinetBodyBg!!.offsetWidth) {
            } else {
                setCurrentMoveLeft(curentLeft + (e.touches[0].clientX - dragStartX))
            }
        }
    };
    const handleTouchEnd = () => {
        setCurrentLeft(curentMoveLeft)
        isDragging.current = false;
    };


    const handleClick = (type: string, value: boolean, gotoStep: string, patient: string = '') => {
        if (gotoStep === '') {return}
        setStepName(gotoStep)
        setButtonsPage(1)
        if (type === "nextStep") {
            if (gotoStep === 'patientQuestions'){
                var cnt = 0
                for (var i=0 ; i<steps!['patientQuestions'].buttons.length; i++){
                    if (steps!['patientQuestions'].buttons[i].answered){
                        cnt++
                    }
                }
                if (cnt === steps!['patientQuestions'].buttons.length){
                    gotoStep = 'patientFirstTextAnswered'
                }
            }

            if (gotoStep !== userData.step){
                try {
                    var rat = userData.rating
                    if (steps![gotoStep].rating > rat* 1){
                        rat = steps![gotoStep].rating + ""
                        userData.rating = rat
                        setUserData(userData)
                    }
                    var prz = userData.prize
                    if (steps![gotoStep].isPrize && steps![gotoStep].prize === 0 && prz === ""){
                        prz = "0"
                        userData.prize = prz
                        setUserData(userData)
                    }else if (prz!="" && steps![gotoStep].isPrize && steps![gotoStep].prize > prz*1){
                        prz = steps![gotoStep].prize + ""
                        userData.prize = prz
                        setUserData(userData)
                    }
                    console.log(userData)

                    setCookie('step', gotoStep)
                    setCookie('patient', steps![gotoStep].patient)
                    setUserData({
                        step: gotoStep,
                        branch: userData.branch,
                        patient: steps![gotoStep].patient
                    })

                    if (steps![gotoStep].rating > 0 ){
                        try {
                            addStepPointsToCookie(String(getCookie('stepPoints')), gotoStep, steps![gotoStep].rating)
                            setCurrentPoints(getTotalPoints(String(getCookie('stepPoints'))))
                        }catch (e){

                        }
                    }

                    if (steps![gotoStep].gematogen ){
                        try {
                            addStepPointsToAchievements(String(getCookie('stepAchievements')), gotoStep)
                            setCurrentAchievements(getTotalAchievements(String(getCookie('stepAchievements'))))
                        }catch (e){

                        }
                    }
                }catch (e){

                }
            }

            // console.log(gotoStep)
            try{
                if (steps![gotoStep].draggable) {
                    setCurrentMoveLeft(cabinetBody!!.offsetWidth / 2 - cabinetBody!!.offsetHeight / 2)
                    setCurrentLeft(cabinetBody!!.offsetWidth / 2 - cabinetBody!!.offsetHeight / 2)
                } else {
                    setCurrentMoveLeft(steps![gotoStep].left)
                    setCurrentLeft(steps![gotoStep].top)
                }
            }catch (e){

            }
            const histSteps = historySteps
            histSteps?.push(gotoStep)
            setHistorySteps(histSteps)

            const stp = steps![gotoStep]
            if (gotoStep === 'rating'){
                console.log(gotoStep)
                stp!.text = '🏆 Ваш рейтинг: RATINGCHANGE/ 300⭐\n\n📈 Как повысить рейтинг?\n✅ За каждое верное врачебное решение вы получаете баллы! 🩺🧠';
                stp!.text = stp!.text.replace("RATINGCHANGE", userData.rating+"");
            }
            // @ts-ignore
            console.log(stp)
            setStep(stp)
        } else if (type === "starCabinet") {
        } else if (type === "closeTelegramBot") {
            if (gotoStep !== 'closeTelegramBot'){
                try {
                    setCookie('step', gotoStep)
                    setCookie('patient', patient)
                    setUserData({
                        step: gotoStep,
                        branch: userData.branch,
                        patient: patient
                    })
                    const updatedUser = {
                        ...userData,
                        step: gotoStep,
                        patient: patient || userData.patient
                    };
                    refreshCabinetState(updatedUser);
                }catch (e){

                }

            }


        } else if (type === "backStep") {
            const histSteps = historySteps
            histSteps?.pop()
            setStep(steps![histSteps[histSteps.length-1]] || 'start')
            setHistorySteps(histSteps)
            if (steps![histSteps[histSteps.length-1]].draggable) {
                setCurrentMoveLeft(cabinetBody!!.offsetWidth / 2 - cabinetBody!!.offsetHeight / 2)
                setCurrentLeft(cabinetBody!!.offsetWidth / 2 - cabinetBody!!.offsetHeight / 2)
            } else {
                setCurrentMoveLeft('50%')
                setCurrentLeft('50%')
            }


        }
    }
    const handleGoToInstruction = () => {
        setCurrentStep('instruction')
        setCurrentMoveLeft(cabinetBody!!.offsetWidth / 2 - cabinetBody!!.offsetHeight / 2)
        setCurrentLeft(cabinetBody!!.offsetWidth / 2 - cabinetBody!!.offsetHeight / 2)
        setStep(steps!['instruction'])
        const histSteps = historySteps
        histSteps?.push('instruction')
        setHistorySteps(histSteps)
    }

    const handleGemoClick = () => {
    }


    return (
        <div id="cabinetBody" className={styles.Container}>
            {step !== null && (
            <>
                <div
                    id="cabinetBodyBg"
                    className={styles.CabinetBackground}
                    style={{
                        transform: step!.transform,
                        height: step!.height,
                        left: curentMoveLeft,
                        top: step!.top,
                        transition: step!.transition,
                        ...(!step!.aspectRatio && {aspectRatio: 'auto', width: '100%'}),
                        ...(step!.gematogen && {filter: 'blur(5px)'})
                    }}
                    onMouseDown={handleMouseDown}
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseUp}
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                >
                    <img src={step!.background} className={styles.stepBg} alt="Step"/>

                    <div className={styles.PCBtn} onClick={() => handleClick("nextStep", false, step!.pcClick, step!.patient)}></div>
                    <div className={styles.gemoBtn} onClick={() => handleGemoClick}></div>
                    <div className={styles.PatientCardBtn} onClick={() => handleClick("nextStep", true, step!.cardClick, step!.patient)}></div>

                </div>

                {(!muted && step!.stepSound!=='')  && (
                    <audio src={step!.stepSound} autoPlay={true} playsInline={true}></audio>
                )}

                {step!.gematogen && (
                    <>
                    <img src={`${base}/images/gemo.png`} className={styles.gemoBg} alt="Step" />
                    </>
                )}

                {!muted ?
                    <img src={`${base}/images/sound.svg`} className={styles.soundMutedIcon} alt="soundMutedIcon" onClick={handleSound}/>
                    :
                    <img src={`${base}/images/sound_off.svg`} className={styles.soundMutedIcon} alt="soundMutedIcon" onClick={handleSound}/>
                }


                {(step!.name !== "" || step!.text !== "") &&
                    <MessageBubble label={step!.name} positionTop={step!.positionTop}
                                   text={step!.text.replace('???', String(currentPoints)).replace('(отображение)', String(currentAchievements))} textHeight={step!.textHeight}
                                   textIsMaxSize={step!.textIsMaxSize}
                                   bitTitle={step!.bitTitle}/>
                }

                {step!.singlePCWindow !== '' && (
                    <Question title={step!.question.title} result={step!.question.result} answers={step!.question.answers} onClickNext={()=>handleClick("nextStep", true, step!.question.nextStep, step!.patient)} onClickNextCorrect={()=>handleClick("nextStep", true, step!.question.nextStepCorrect, step!.patient)}/>
                )}


                {stepName !== 'openImage2' ?
                    <div className={styles.stepButtons}
                    style={{
                        ...(step!.singlePCWindow !== '' && {justifyContent: 'center'})
                    }}>
                        {step!.buttons!.map((button, index) => (
                            <Button
                                label={button.text}
                                redColor={button.redColor}
                                answered={button.answered}
                                canDisabled={button.canDisabled}
                                width={button.width}
                                startInvisible={button.startInvisible}
                                page={button.page}
                                currentPage={buttonsPage}
                                greenColor={button.greenColor}
                                veryRedColor={button.veryRedColor}
                                onClick={() => {
                                    if (button.canDisabled){
                                        step!.buttons[index].answered = true
                                        var anscount = 0
                                        for (var i = 0; i<step!.buttons!.length; i++) {
                                            if (step!.buttons![i].answered){
                                                anscount++;
                                            }
                                        }
                                        if (anscount === step!.buttons!.length){
                                            step!.buttons![step!.buttons!.length-1].answered = false
                                            step!.buttons![step!.buttons!.length-1].startInvisible = false
                                        }
                                    }
                                    if (button.gotoStep === 'patientDizagnose1' || button.gotoStep === 'patientDizagnose2'){
                                        steps!['patientDizagnoses'].buttons[index].answered = true
                                    }
                                    if (button.text === 'arrow_prev'){
                                        setButtonsPage(1)
                                    }else if (button.text === 'arrow_next'){
                                        setButtonsPage(2)
                                    }else{
                                        handleClick(button.type, button.value, button.gotoStep, button.patient)
                                    }
                                    if (button.clickSound){
                                        var audio = new Audio(`${base}/audio/click.mp3`);
                                        audio.play()
                                    }
                                }}
                            />
                        ))}
                    </div>
                    :
                    <div className={styles.fiveSmallButtons}>
                        {step!.buttons!.map((button, index) => (
                            <Button
                                label={button.text}
                                redColor={button.redColor}
                                answered={button.answered}
                                onClick={() => {
                                    if (button.gotoStep === 'patientQuestion1' || button.gotoStep === 'patientQuestion2' || button.gotoStep === 'patientQuestion3' || button.gotoStep === 'patientQuestion4' || button.gotoStep === 'patientQuestion5'){
                                        steps!['patientQuestions'].buttons[index].answered = true
                                    }
                                    handleClick(button.type, button.value, button.gotoStep, button.patient)
                                    if (button.clickSound){
                                        var audio = new Audio(`${base}/audio/click.mp3`);
                                        audio.play()
                                    }
                                }}
                            />
                        ))}
                    </div>
                }


                {step!.patientCard.pages.length > 0 && (
                    <PatientCard
                        pages={step!.patientCard.pages}
                        onAnalyzesClick={() => handleClick("nextStep", false, step!.patientCard.analyzesStep, step!.patient)}
                        onCloseClick={() => handleClick("nextStep", false, step!.patientCard.closeClick, step!.patient)}
                    />
                )}
                {step!.patientAnalyzes.analyzes.length > 0 && (
                    <PCWindow
                        windowType={step!.patientAnalyzes.windowType}
                        windowStartPage={step!.patientAnalyzes.windowStartPage}
                        cards={step!.patientAnalyzes.analyzes}
                        cardsHeight={step!.patientAnalyzes.analyzesHeights}
                        onClick={() => handleClick("nextStep", true, step!.patientAnalyzes.toCardClick, step!.patient)}
                        onClickEnter={() => handleClick("nextStep", true, step!.patientAnalyzes.nextClick, step!.patient)}
                    />
                )}


                {step!.teachBlock.pages.length > 0 && (
                    <Teach
                        pages={step!.teachBlock.pages}
                        onClick={() => handleClick("nextStep", true, step!.teachBlock.closeClick, step!.patient)}
                    />
                )}


            </>
            )}
        </div>
    );
}
